export default __webpack_public_path__ + "static/avatar-kayi-common-1-cover-3529549b66ea726e406e8f793b60ed09.png";